import { useLayoutEffect } from 'preact/hooks';

/***
 * The hook calls the callback when the image gets loaded
 * @param target The target image
 * @param callback The callback to be called when the image loads
 */
export function useOnImageLoad(target: HTMLImageElement | null, callback: () => void) {
  useLayoutEffect(() => {
    if (!target) return;

    if (target.complete) return callback();

    target.addEventListener('load', callback);
    return () => target.removeEventListener('load', callback);
  }, [target, callback]);
}
